module.exports = __webpack_public_path__ + "img/square-dashed.cc9ce8a4.svg";